import { Popconfirm } from 'antd'
import { isBoolean } from 'lodash'

import { ActionButton } from '../ActionButton'

import { ConfirmButtonProps } from './interface'

const DEFAULT_LOADING = {
  delay: 150
}

export const ConfirmButton = ({
  title,
  message,

  /* -------------------------------------------------------------------------- */
  /*                              PopConfirm Props                              */
  /* -------------------------------------------------------------------------- */
  confirmIcon,
  placement = 'left',
  trigger = 'click',
  getPopupContainer,
  cancelText = '取消',
  cancelButtonProps,
  onCancel,
  confirmText = '确定',
  confirmType,
  confirmButtonProps,
  onConfirm,

  /* -------------------------------------------------------------------------- */
  /*                             ActionButton Props                             */
  /* -------------------------------------------------------------------------- */
  disabled,
  loading,
  ...restProps
}: ConfirmButtonProps) => {
  const btnLoading = loading
    ? isBoolean(loading)
      ? DEFAULT_LOADING
      : loading
    : false

  return (
    <Popconfirm
      autoAdjustOverflow
      cancelButtonProps={cancelButtonProps}
      cancelText={cancelText}
      description={title ? message : undefined}
      disabled={disabled}
      getPopupContainer={getPopupContainer}
      icon={confirmIcon}
      okButtonProps={confirmButtonProps}
      okText={confirmText}
      okType={confirmType}
      placement={placement}
      title={title ?? message}
      trigger={trigger}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      <ActionButton
        disabled={disabled}
        loading={btnLoading}
        type='link'
        {...restProps}
      />
    </Popconfirm>
  )
}
